import { SensorProduct } from 'src/sensors/list/SensorsPageMapping.ts';
import { FlowRangeFields } from 'src/sensors/FlowUnitsRadioButtons/FlowUnitsOptions.ts';
import { AttributesListItemMulti } from 'src/utils/createAttributesItem.ts';
import { MESSAGES } from 'src/modules/common/constants.ts';
import { AttributesAliases } from 'src/generated/dict.ts';
import { convertProbeLength } from 'src/sensors/list/convertProbeLength.ts';
import { convertFS } from 'src/sensors/list/convertFS.ts';
import { isRoomSensor } from 'src/modules/common/utils/isRoomSensor';

const NO = '@no';

export function prepareSelectionAttributes(
    product: SensorProduct,
    isAmericas: boolean,
    isImperial: boolean,
    selectedFlowRange: FlowRangeFields,
): AttributesListItemMulti[] {
    const displayTypeAlias = isRoomSensor(product.SensorApplication)
        ? AttributesAliases.DisplayType
        : AttributesAliases.displayTypeSAS;
    const displayTypeValue = isRoomSensor(product.SensorApplication)
        ? product.DisplayType
        : product.displayTypeSAS;

    return [
        [MESSAGES.Description, product.ProductSubHeader],
        [
            displayTypeAlias,
            displayTypeValue || { raw: [NO], localized: [NO] }],
        [AttributesAliases.SensorApplication, product.SensorApplication],
        [AttributesAliases.dn, product.DN],
        [AttributesAliases.OutputSignal, product.OutputSignal],

        [AttributesAliases.MeasuredValues, product.MeasuredValues],
        [
            AttributesAliases.ProbeLength,
            isAmericas ? product.ProbeLength : convertProbeLength(product.ProbeLength, isImperial),
        ],
        [AttributesAliases.MeasuringRangeCO2, product.MeasuringRangeCO2],
        ...(isImperial ? [
            [AttributesAliases.i_MeasuringRangeTemperature, product.i_MeasuringRangeTemperature],
        ] : [
            [AttributesAliases.m_MeasuringRangeTemperature, product.m_MeasuringRangeTemperature],
        ]) as AttributesListItemMulti[],
        [AttributesAliases.MeasuringRangeRH, product.MeasuringRangeRH],
        [
            isImperial ? AttributesAliases.i_flow : AttributesAliases.m_flow,
            isImperial ? (product.i_flow || convertFS(product.m_flow, isImperial)) : product.m_flow,
        ],
        ...(selectedFlowRange.length === 0 ? [
            [
                isAmericas ? AttributesAliases.FlowRangeGpm : AttributesAliases.FlowRangeM3h,
                { raw: [], localized: [] },
            ],
        ] : []) as AttributesListItemMulti[],
        ...(selectedFlowRange && selectedFlowRange.length > 0 ? [
            [AttributesAliases[selectedFlowRange], product[selectedFlowRange]],
        ] : []) as AttributesListItemMulti[],
        [AttributesAliases.pressureAir, product.pressureAir],
        [AttributesAliases.AdditionalFeatures, product.AdditionalFeatures],
        [AttributesAliases.certification, product.certification],
        [AttributesAliases.mountingType, product.mountingType],
    ];
}
